
  import * as ipxRuntime$kWxKzC_4536fPs4DiRW6ZZAWhmoP_3JEmbHXL7R8VKHvQ from '/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$kWxKzC_4536fPs4DiRW6ZZAWhmoP_3JEmbHXL7R8VKHvQ, defaults: {} }
    }
  }
